import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as actions from '../redux/actions/index';
import NationalMap from "../charts/NationalMap/index";
import ScatterPlot from "../charts/ScatterPlot/index";

import './NationalCard.css';

class NationalComboCard extends Component {
  render() {
    const selectState = stateId => {
      this.props.actions.selectState(stateId);
      this.props.actions.selectPage('state');
    };
    return (
      <Card className="NationalComboCard" noHovering={true} loading={this.props.loading}>
        <Row gutter={10}>
          <h2 className="subtitle">
            National Multivariate by State - {this.props.year}<br/>
            <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
            {this.props.xLabel} &nbsp;
            <small>vs</small> &nbsp;
            <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
            {this.props.yLabel}
          </h2>
          <Col xs={24} md={14}>
            <NationalMap
              type="z"
              showLabels={true}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              dimX={this.props.xField}
              dimY={this.props.yField}
              dict={this.props.dict}
              data={this.props.data}
              year={this.props.year}
              onClick={selectState}/>
          </Col>
          <Col xs={24} md={10}>
            <ScatterPlot
              type="z"
              dimId={this.props.idField}
              dimX={this.props.xField}
              dimY={this.props.yField}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              year={this.props.year}
              data={this.props.data}
              onClick={selectState}/>
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.states.loading || store.dimensions.loading,
    data: store.states.data,
    dict: store.states.dict,
    idField: store.dimensions.stateKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(NationalComboCard);



// WEBPACK FOOTER //
// ./src/containers/NationalComboCard.js